import React, { Component } from 'react'
import Property from '../assets/images/property.jpg'
import Slider from 'react-slick'
import Prev from '../assets/images/greyarrowprev.png'
import Next from '../assets/images/greyarrownext.png'

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      className={className}
      style={{ ...style }}
      src={Next}
      alt='next gallery item'
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      className={className}
      style={{ ...style }}
      src={Prev}
      alt='last gallery item'
      onClick={onClick}
    />
  );
}

class PropertyLanding extends Component {
  state = {
    activeSlide: 0,
  }
  constructor(props) {
    super(props);
    this.state = {
      slider: null,
      thumbs: null
    };
  }

  componentDidMount() {
    this.setState({
      slider: this.slider,
      thumbs: this.thumbs,
    });
  }


  render() {
    const data = this.props;

    const settings = {
      infinite: false,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 10000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      pauseOnHover: false,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
          }
        },
      ]
    }


    const thumbSettings = {
      slidesToShow:3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      asNavFor: this.state.slider,
      swipeToSlide:true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
      ],
    }


    return (
      <>
        <section className="property-landing">
          <div className="property-landing__inner outercontainer">
            <div className="property-landing__inner--left">
              <div className="property-landing__inner--left--top">
                <Slider className="image__carousel" ref={slider => (this.slider = slider)} {...settings}>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                </Slider>
                <div className="thumbs-div">
                  <Slider className="menu__thumbs" ref={thumbs => (this.thumbs = thumbs)} {...thumbSettings}>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>
                    <div className="image__item">
                      <img className="background" src={Property} alt="WhiteFox"/>
                    </div>

                  </Slider>
                </div>
              </div>
              <div className="property-landing__inner--left--middle">
                <h5>{data.tagword}</h5>
                <p dangerouslySetInnerHTML={{ __html: data.content }}/>
                <h5>{data.tagline}</h5>
                <p>{data.information}</p>
                <ul>
                  <li><a href={data.download_link}>{data.download_statement}</a></li>
                </ul>
                <iframe title="iframe" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.7362134699183!2d144.9757588153183!3d-37.79622127975548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad643212c4137e1%3A0xdb1bff7fb9c1ef73!2s404%20Fitzroy%20St%2C%20Fitzroy%20VIC%203065!5e0!3m2!1sen!2sau!4v1576546538567!5m2!1sen!2sau"/>
              </div>
              <div className="property-landing__inner--left--bottom">
                <img src={data.image.url} alt='Whitefox' />
              </div>
            </div>
            <div className="property-landing__inner--right">
              <div className="property-landing__inner--right--top">
                  <h6>{data.title}</h6>
                  <h6>{data.subheading}</h6>
                  <ul>
                    { data.specs.map((el, i) => (
                      <li className="specs" key={i}>{el.spec}</li>
                    ))}
                  </ul>
                  <h5 className="form-title">{data.form_title}</h5>
                  <form>
                  <input classsName="name" placeholder={data.namePlaceholder}/>
                  <input classsName="email" placeholder={data.emailPlaceholder}/>
                  <input classsName="number" placeholder={data.numberPlaceholder}/>
                  <textarea row="6" placeholder={data.enquiryPlaceholder}></textarea>
                  <button className="contactbtn" type="submit">{data.buttonText}</button>
                </form>
              </div>
              <div className="property-landing__inner--right--bottom">
                { data.agents.map((el, i) => (
                  <div className="agent" key={i}>
                    <div className="agent--top">
                      <img src={el.agent.url} alt="WhiteFox"/>
                    </div>
                    <div className="agent--bottom">
                      <h5 className="name">{el.agentName}</h5>
                      <p className="phone"> {el.phone} </p>
                      <p className="email"> {el.email} </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default PropertyLanding
